import { Directive, HostListener, Input } from '@angular/core';

import { GoogleAnalyticsService } from '../../services/google-analytics/google-analytics.service';

@Directive({
  selector: '[appGoogleAnalytics]'
})
export class GoogleAnalyticsDirective {

    @Input() appGoogleAnalytics: any;

    constructor (private googleAnalytics: GoogleAnalyticsService) {}

    @HostListener('click')
    onClick () {
        this.googleAnalytics.sendEvent(this.appGoogleAnalytics);
    }

}
